module.exports = __webpack_public_path__ + "static/media/Home2.853a4e28.png";